// extracted by mini-css-extract-plugin
module.exports = {"container":"UnpublishedPageInfobox_container__mSEvJ"};